import { onboardingVideoUrl as introVideo } from "@features/onboarding/constants";

export interface IPageIntro {
  key: string;
  path: string;
  title: string;
  description: string;
  /** Without one the placeholder block renders. */
  videoUrl?: string;
}

export const PAGE_INTROS: IPageIntro[] = [
  {
    key: "analytics",
    path: "/pages/analytics",
    title: "See who's reading your decks",
    description:
      "Track opens, time on each slide, and where prospects drop off. Know exactly who's interested before you follow up.",
    videoUrl: introVideo("analytics"),
  },
  {
    key: "stories",
    path: "/pages/editor",
    title: "All your decks in one place",
    description:
      "Every story you create lives here. Organize them into folders and keep everything easy to find as your library grows.",
    videoUrl: introVideo("stories"),
  },
  {
    key: "integrations",
    path: "/pages/profile/integrations",
    title: "Supercharge your decks",
    description:
      "Link Storydoc to your CRM and tools so deck activity flows where your team already works. Set it once and let the data sync itself.",
    videoUrl: introVideo("integrations"),
  },
  {
    key: "design",
    path: "/pages/design",
    title: "Make every deck on-brand",
    description:
      "Set your brand, colors and fonts once so everything you create looks unmistakably yours. No design skills required.",
    videoUrl: introVideo("design"),
  },
  {
    key: "automations",
    path: "/pages/automations",
    title: "Let Storydoc work for you",
    description:
      "Use the API to create decks, pull engagement data, and wire Storydoc into your own systems. Build the workflows your team needs.",
    videoUrl: introVideo("automations"),
  },
];

export const findPageIntro = (pathname: string): IPageIntro | undefined =>
  PAGE_INTROS.find((intro) => intro.path === pathname);
